module.exports = __webpack_public_path__ + "img/honner_1.3985a6cc.webp";